<template>
  <el-dialog title="新增视频评论信息" :center="true" :visible.sync="addVisible">
    <div class="add-body">
      <el-form
        ref="submitForm"
        :model="submitData"
        :rules="validatorRules"
        label-width="200px"
        class="add-body-form"
      >
        <div class="add-body-div">
          <div class="add-item-view">
            <el-form-item label="视频ID" prop="videoDataId" >
              <el-input
                      v-model="submitData.videoDataId"
                      placeholder="请填写-视频ID"
                      maxlength="10"
                      show-word-limit>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="add-body-div">
          <div class="add-item-view">
            <el-form-item label="平台用户ID" prop="platformUserId" >
              <el-input
                      v-model="submitData.platformUserId"
                      placeholder="请填写-平台用户ID"
                      maxlength="10"
                      show-word-limit>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="add-body-div">
          <div class="add-item-view">
            <el-form-item label="评论内容" prop="commentText" >
              <el-input
                      v-model="submitData.commentText"
                      placeholder="请填写-评论内容"
                      maxlength="10"
                      show-word-limit>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="add-body-div">
          <div class="add-item-view">
            <el-form-item label="星级" prop="starNum" >
              <el-input
                      v-model="submitData.starNum"
                      placeholder="请填写-星级"
                      maxlength="10"
                      show-word-limit>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <el-divider content-position="center" v-if="false">上传图片</el-divider>
        <div class="add-body-div" v-if="false">
            <div class="add-item-view">
                <el-form-item label="图片信息:" >
                    <div class="upload-item-view">
                        <UploadImg
                            class="upload-item"
                            ref="uploadFile"
                            :uploadApi="uploadUrl"
                            :fileList="submitData.attachList"
                            @subBack="uploadAttachSuccess"
                            @handleFileDelete="uploadAttachDelete"
                            :limit="10"
                            :headers="uploadHeaders"
                        />
                    </div>
                </el-form-item>
            </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancel" size="mini">取 消</el-button>
    <el-button type="primary" @click="handleSubmit" size="mini">提 交</el-button>
  </span>
  </el-dialog>
</template>
<script>
import Api from "@/services";
import baseUtils from '@/utils/baseUtils'
import UploadImg from "@/components/UploadImg";
export default {
  components: {
    UploadImg:UploadImg
  },
  name:"ItemAdd",
  data() {
    return {
      title: "新增",
      addVisible: false,
      submitData: {
        videoDataId:'',
        platformUserId:'',
        commentText:'',
        starNum:'',
        attachList:[],
      },
      uploadUrl: process.env.BASE_API+`/api/platformFile/uploadFile`,
      deleteFileUrl: process.env.BASE_API+`/api/platformFile/deleteFileByFileName`,
      uploadHeaders:{
        token: localStorage.getItem('token') || ''
      },
      validatorRules:{
        videoDataId: [
            { required: true, message: '请规范填写视频ID', trigger: 'blur' }
        ],
        platformUserId: [
            { required: true, message: '请规范填写平台用户ID', trigger: 'blur' }
        ],
        commentText: [
            { required: true, message: '请规范填写评论内容', trigger: 'blur' }
        ],
        starNum: [
            { required: true, message: '请规范填写星级', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    //上传文件成功
    uploadAttachSuccess(fileName,file) {
      //console.log('上传文件成功返回:file:'+JSON.stringify(file));
      if(this.$isNull(fileName)){
          return
      }
      if(fileName.length === 0){
          return;
      }
      if(this.$isNull(file)){
          return
      }
      //随机数
      let uuId = baseUtils.randomString();
      //文件名称
      let fileNameItem = {
          status:'success',
          name:fileName,
          percentage:100,
          uid:uuId,
          raw:{
              uid:uuId
          },
          url:this.handleImageUrl(fileName)
      }
      if(this.$isNull(this.submitData.attachList)){
          this.submitData.attachList = new Array();
      }
      this.submitData.attachList.push(fileNameItem);
      console.log('上传成功后的文件集合:'+JSON.stringify(this.submitData.attachList))
    },
    //删除文件
    async uploadAttachDelete(fileName) {
      console.log('删除文件fileName:'+fileName);
      if(this.$isNull(fileName)){
          return
      }
      if(this.$isNull(this.submitData.attachList)){
          this.submitData.attachList = new Array();
      }
      const index = this.submitData.attachList.findIndex((item) => {
          return item.name == fileName
      })
      this.submitData.attachList.splice(index, 1);
      const res = await Api.deleteFileApi({
          name:fileName
      });
      console.log('删除文件结果:'+JSON.stringify(res))
      if (res.success) {
          console.log('删除成功')
      }
      console.log('删除后的文件集合:'+this.submitData.attachList);
    },
    //处理展示
    showAdd(data) {
      console.log('data:'+JSON.stringify(data))
      if(data){

      }
      this.init();
      this.addVisible = true;
    },
    async setOtherData(){

    },
    //处理初始化
    async init() {
      await this.setOtherData();
      const loading = this.$loading({
        lock: true,
        text: "正在请求。。。",
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      });
      loading.close();
    },
    clearAll(){
     console.log('触发清除所有')
     this.submitData = {
       videoDataId:'',
       platformUserId:'',
       commentText:'',
       starNum:'',
       attachList:[],
     }
     //清除文件
     /*if(this.$baseUtils.isNull(this.$refs.uploadFile)){
       this.$refs.uploadFile.clearFiles()
     }*/
    },
    handleCancel(){
      this.addVisible = false
      this.clearAll();
    },
    //处理提交
    handleSubmit() {
      this.$refs.submitForm.validate((valid) => {
        const params = {};
        if (valid) {
            Object.assign(params, this.submitData);
            //处理附件
            /*let attachList = this.submitData.attachList
            if(!this.$isNull(attachList)){
                let itemNameList = new Array();
                attachList.map((item) => {
                    itemNameList.push(item.name);
                })
                params.attachFileList = itemNameList
            }else{
                params.attachFileList = new Array();
            }*/
            console.log("params", params);
        }else{
          this.$message.error('验证异常');
          return;
        }
        const loading = this.$loading({
          lock: true,
          text: "正在提交...",
        });
        try {
          Api.addVideoCommentItem(params).then((res) => {
            if (res.success) {
              this.addVisible = false;
              this.$emit("handleSuccess");
              this.$message({
                  message: "操作成功!",
                  type: "success",
              });
              this.clearAll()
            } else {
                this.$message.error('服务器异常');
            }
          });
          loading.close();
        } catch (error) {
          this.clearAll()
          loading.close();
          this.$message.error(error.message || error.msg || "服务器异常");
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.add-body{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  .add-body-form{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    align-items: flex-start;
    .add-body-div{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      width: auto;
      .add-item-view{

      }
      .upload-item-view{
        .upload-item{

        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ItemAdd.vue?449f5710